"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UITag = _interopRequireDefault(require("../../tag/UITag"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var MultiSelectValue = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MultiSelectValue, _Component);

  function MultiSelectValue() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MultiSelectValue);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MultiSelectValue)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleMouseDown = function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          value = _this$props.value;

      if (evt.type === 'mousedown' && evt.button !== 0) {
        return;
      }

      if (onClick) {
        evt.stopPropagation();
        onClick((0, _SyntheticEvent.default)(value));
      }
    };

    _this.handleCloseMouseDown = function (evt) {
      var _this$props2 = _this.props,
          onRemove = _this$props2.onRemove,
          value = _this$props2.value;
      onRemove(value); // Prevent input focus, which leads to scroll jank (#1724)

      evt.preventDefault();
      evt.stopPropagation();
    };

    return _this;
  }

  (0, _createClass2.default)(MultiSelectValue, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          closeable = _this$props3.closeable,
          disabled = _this$props3.disabled,
          value = _this$props3.value;
      var computedUse = value.tagUse || 'default';
      return _react.default.createElement(_UITag.default, {
        _onCloseMouseDown: this.handleCloseMouseDown,
        _bordered: true,
        closeable: typeof closeable === 'boolean' ? closeable : !disabled && value.clearableValue !== false,
        onMouseDown: this.handleMouseDown,
        onTouchEnd: this.handleMouseDown,
        use: computedUse
      }, children);
    }
  }]);
  return MultiSelectValue;
}(_react.Component);

exports.default = MultiSelectValue;
MultiSelectValue.propTypes = {
  children: _propTypes.default.node,
  closeable: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  value: _propTypes.default.object
};
MultiSelectValue.displayName = 'MultiSelectValue';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/input/utils/MultiSelectValue.js
// module id = 739
// module chunks = 209 210 211 212